// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-video"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M15.75 12.0001L9 15.8973L9 8.10303L15.75 12.0001Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 12V21H3V3H12M15.75 12L9 15.8971L9 8.10289L15.75 12Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19 2.75L19.7 4.29996L21.25 5L19.7 5.70004L19 7.25L18.3 5.70004L16.75 5L18.3 4.29996L19 2.75Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-video')
export default class AiVideoIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-video',
    }
  }
}
